export const TradeSectionHeight = 'calc(100dvh - 130.5px)';
export const SideBarHeight = 'calc(100dvh - 56px)';
export const TradeTableScrollHeight = 55 * 8;
export const PumpTableScrollHeight = 55 * 5;
export const PumpTableScrollHeightLong = 55 * 11;
export const MAX_WIDTH_IN_WINDOW = 500;
export const MIN_SCREEN_WIDTH = 762
export const HEADER_HEIGHT_PC = 84
